<script>
	import { onMount, onDestroy } from "svelte";
	import * as L from "leaflet";
	import { filteredPingStationCount } from './adsbMarkerSet'

	export let device;
	export let layer;
	export let filterRadioId

	// Taken from feather icons
	const eyeSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>'

	let marker;

	$: updateMarker(device, filterRadioId, $filteredPingStationCount)
	$: baseId = device && BigInt(device.radioId).toString(16)

	onMount(() => {
		marker = L.marker([0, 0]);
		updateMarker(device);
		marker.addTo(layer);
		marker.on("click", () => {
			if (filterRadioId === baseId) {
				filterRadioId = null
			} else {
				filterRadioId = baseId
			}
			marker.setIcon(makeIcon())
		})
	});

	onDestroy(() => {
		if (!marker) return;
		marker.removeFrom(layer);
		marker.off("click")
	});

	function makeIcon() {
		return L.divIcon({
				className: `srsIcon${filterRadioId === baseId ? ' filtering' :''}`,
				html: eyeSVG,
				iconSize: [25, 25],
				iconAnchor: [12.5, 12.5],
			})
	}

	function updateMarker(device) {
		if (!marker || !device.info) return;
		
		marker.setLatLng([device.latitude, device.longitude])
		let popup = `
			<div class="srsPopup">
				<h2>${device.name}</h2>`
		if (device.info && device.info.guid) {
			popup += `<div>GUID</div><div>${device.info.guid}</div>
				<div>Version</div><div>${device.info.versionMajor}.${device.info.versionMinor}.${device.info.versionBuild}</div>
				<div>Alt (MM)</div><div>${device.info.altMM}</div>
				<div>GPS Status</div><div>${device.info.gpsStatus}</div>
				<div>Type</div><div>${device.info.type ?? 'PingStation'}</div>`
		}
		if ($filteredPingStationCount && baseId === filterRadioId) {
			popup += `<div>Target Count</div><div>${$filteredPingStationCount}</div>`
		}
		popup += '</div>'

		marker.bindTooltip(popup, {offset:[16, 0]})
		
		marker.setIcon(makeIcon())
		
	}
</script>

<style>
	:global(.srsPopup) {
		display: grid;
		grid-template-columns: auto auto;
		gap: 4px;
	}

	:global(.srsPopup h2) {
		grid-column: 1 / span 2;
		padding:0;
		margin: 0;
	}

	:global(.srsIcon) {
		border:1px solid black;
		color: black;
		background: cornflowerblue;
		border-radius: 50%;
	}

	:global(.srsIcon svg) {
		padding:4px;
	}

	:global(.srsIcon.filtering) {
		background-color:orange;
	}
</style>